import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={29}
    height={29}
    viewBox="0 0 29 29"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      d="M24.3 9.34c-.38-5-4.56-8.95-9.65-8.95C9.56.39 5.37 4.34 5 9.34c-2.39 0-4.34 1.95-4.34 4.34v3.25c0 2.39 1.95 4.34 4.34 4.34h3.38c1.3 0 2.36-1.06 2.36-2.36V11.7c0-1.3-1.06-2.36-2.36-2.36H7.03a7.658 7.658 0 0 1 7.62-6.92c3.98 0 7.25 3.05 7.62 6.92h-1.35c-1.3 0-2.36 1.06-2.36 2.36v7.21c0 1.3 1.06 2.36 2.36 2.36h1.24c-.45 1.61-1.92 2.8-3.67 2.8h-.12a3.3 3.3 0 0 0-3.13-2.28h-1.19c-1.81 0-3.29 1.48-3.29 3.29s1.48 3.29 3.29 3.29h1.19a3.3 3.3 0 0 0 3.13-2.28h.12c2.87 0 5.26-2.09 5.74-4.83h.06c2.39 0 4.34-1.95 4.34-4.34v-3.25c0-2.4-1.94-4.34-4.34-4.34l.01.01ZM8.71 11.7v7.21c0 .18-.15.33-.33.33H5c-1.28 0-2.31-1.04-2.31-2.31v-3.25c0-1.28 1.04-2.31 2.31-2.31h3.38c.18 0 .33.15.33.33Zm6.53 14.65h-1.19a1.26 1.26 0 0 1 0-2.52h1.19a1.26 1.26 0 0 1 0 2.52Zm11.37-9.41c0 1.28-1.04 2.31-2.31 2.31h-3.38c-.18 0-.33-.15-.33-.33v-7.21c0-.18.15-.33.33-.33h3.38c1.28 0 2.31 1.04 2.31 2.31v3.25Z"
    />
  </Svg>
);
export default SvgComponent;
